import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Container, Typography, Paper, TextField, Button, Stack } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { ThemeContext } from 'components/common/App';
import rpc, { buildRequest, signoutAndRedirectToIndex } from 'lib/rpc';

// Styles for the hidden input file
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function MaterialCreatePage() {
  const theme = useContext(ThemeContext);
  const navigate = useNavigate();

  const [materialName, setMaterialName] = React.useState('');
  const [materialFile, setMaterialFile] = React.useState(null);
  const [filename, setFilename] = React.useState('No file selected');

  useEffect(() => {
    theme.changeTheme("light-bg");
    window.scrollTo(0, 0); // Make sure to be on top of the page
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setMaterialFile(e.target.result.split(',')[1]); // base64 part
      };
      reader.readAsDataURL(file);
      setFilename(file.name);
    }
    setFilename(event.target.files[0].name)
  }

  const handleCreateMaterial = () => {
    if (!materialName || !materialFile) {
      alert("Please provide both material name and file.");
      return;
    }
    rpc.post(
      "",
      buildRequest("admin.materials.create", {
        name: materialName,
        filename: filename,
        file: materialFile,
      })
    ).then(response => {
      if (!response.data.result.message) {
        navigate("/materials", { replace: true });
      } else {
        if (response.data.result.code === 5) {
          signoutAndRedirectToIndex();
        }
        console.error(response.data.result);
      }
    });
  };

  return (
    <Container>
      <Helmet>
        <title>Create Material</title>
      </Helmet>
      <Typography variant="h4" gutterBottom>
        Create Material
      </Typography>

      <Paper>
        <Stack spacing={2} sx={{ padding: 2 }}>
          <TextField
            label="Material Name"
            fullWidth
            margin="normal"
            variant="outlined"
            onChange={(e) => setMaterialName(e.target.value)}
          />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
          >
            Select Video
            <VisuallyHiddenInput
              type="file"
              onChange={handleFileChange}
            />
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => handleCreateMaterial()}
          >
            Create Material
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}